<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { chairTL } from '../../generated/tl';
import { useAuth } from '../../composables/useAuth';
import { useI18n } from '../../composables/I18n';
import { WMModal } from '../../composables/WM';
import ChairPickerPanel from './ChairPickerPanel.vue';
import Loader from '../Loader.vue';
import type { ChairListItemDto } from '../../types/chair';

/**
 * Voluntary re-switch of the "acting as" chair (docs/tasks/022-journal.md část 1) — opened from
 * App.vue by clicking the username; unlike ChairGate.vue this one CAN be cancelled.
 */
const props = defineProps<{ modal: WMModal }>();

const { t } = useI18n();
const { currentUser, currentChairId, setCurrentChair } = useAuth();

const chairs = ref<ChairListItemDto[]>([]);
const loading = ref(true);

onMounted(async () => {
  const all = await chairTL.findChairs();
  chairs.value = all.filter(c => c.user.id === currentUser.value?.id);
  loading.value = false;
});

const pick = async (chairId: number) => {
  await setCurrentChair(chairId);
  // docs/tasks/024-acl.md Część 2: reload so every page re-derives permissions/data for the
  // newly-picked chair instead of showing stale (ex-chair's) authorization state.
  window.location.reload();
};
</script>

<template>
  <Loader v-if="loading" />
  <ChairPickerPanel v-else :chairs="chairs" :current-chair-id="currentChairId" @pick="pick" />

  <div class="d-flex gap-2 mt-4">
    <button type="button" class="btn btn-secondary" @click="props.modal.close(undefined)">{{ t('common.cancel') }}</button>
  </div>
</template>
